document.addEventListener('click', function(e) {
  console.log('🖱️ CLICKED ELEMENT:', e.target);
}, true);

// Wait for EComposer content to load before setting up cart handlers
let cbi_cart_toggle = null;

const findCartToggle = () => {
  return document.querySelector('a[href="/cart"]') || 
         document.querySelector('#cart-icon-bubble-test') || 
         document.querySelector('#cart-icon-bubble');
}

const setupCartToggle = (element) => {
  if (element && !element.hasAttribute('data-cbi-cart-setup')) {
    element.setAttribute('href', '#cart');
    element.setAttribute('data-cbi-cart-setup', 'true');
    console.log('Cart toggle setup completed for:', element.id || element.className);
  }
}

const hideCBICart = () => {
  const cbi_cart_overlay = document.querySelector('.cbi-cart_overlay');
  if (cbi_cart_overlay) {
    cbi_cart_overlay.style.opacity = "0";
    const cbi_cart_shell = document.querySelector('.cbi-cart_shell');
    if (cbi_cart_shell) {
      cbi_cart_shell.style.transform = "translateX(100%)";
    }
    setTimeout(() => { 
      cbi_cart_overlay.style.display = "none" 
    }, 900); // Slightly faster than the transition, helps it feel "snappy"
  }
}

const showCBICart = () => {
  // Show the CBI cart overlay and slide in the cart shell
  const cbi_cart_overlay = document.querySelector('.cbi-cart_overlay');
  const cbi_cart_shell = document.querySelector('.cbi-cart_shell');
  const trash_icons = document.querySelectorAll('.trash-icon svg');
  
  if (cbi_cart_overlay && cbi_cart_shell) {
    // Enable animation before showing
    cbi_cart_shell.classList.add('animate-ready');
    
    cbi_cart_overlay.style.opacity = "1";
    cbi_cart_overlay.style.display = "block";
    cbi_cart_shell.style.transform = "translateX(0px)";
    trash_icons.forEach(svg => {
      svg.style.visibility = "visible";
    });
    
    // Add event listener to close button
    const closeButton = document.querySelector(".cbi-cart_close-button");
    if (closeButton && !closeButton.hasAttribute("data-event-listener-added")) {
      closeButton.setAttribute("data-event-listener-added", "true");
      closeButton.addEventListener("click", function (_e) {
        hideCBICart();
      });
    }

    // Add event listener to close cart when clicking outside of it
    const cartOverlay = document.querySelector(".cbi-cart_overlay");
    if (cartOverlay && !cartOverlay.hasAttribute("data-event-listener-added")) {
      cartOverlay.setAttribute("data-event-listener-added", "true");
      cartOverlay.addEventListener("click", function (_e) {
        hideCBICart();
      });
    }

    // Ensure checkout button event listener is attached
    setupCheckoutButtonEventListener();

    // Check minimum bottles requirement and update button state immediately
    setTimeout(() => {
      checkMinimumBottles();
    }, 50);
  };
};

// Function to initialize cart toggle
function initializeCartToggle() {
  const toggle = findCartToggle();
  if (toggle) {
    setupCartToggle(toggle);
    cbi_cart_toggle = toggle;
    console.log('Found and setup cart toggle:', toggle.id);
    return true;
  } else {
    console.log('Cart toggle not found yet...');
    return false;
  }
}

// Try to initialize immediately
initializeCartToggle();

cbi_cart_toggle.addEventListener("click", function (e) {
  e.preventDefault();
  showCBICart();
});

// Add checkout button event listener that respects disabled state
document.addEventListener("DOMContentLoaded", function () {
  setupCheckoutButtonEventListener();
});

// Function to setup checkout button event listener
function setupCheckoutButtonEventListener() {
  const checkoutButton = document.getElementById("checkout-button");
  if (
    checkoutButton &&
    !checkoutButton.hasAttribute("data-event-listener-added")
  ) {
    // Mark that we've added the event listener to avoid duplicates
    checkoutButton.setAttribute("data-event-listener-added", "true");

    checkoutButton.addEventListener("click", function (e) {
      // Prevent default action
      e.preventDefault();
      e.stopPropagation();

      // Check if button is disabled
      if (this.disabled || this.classList.contains("disabled")) {
        // Show the minimum bottles message if it's not already showing
        const messageElement = document.getElementById(
          "minimum-bottles-message"
        );
        if (messageElement) {
          messageElement.style.display = "block";
          // Flash the message to draw attention
          messageElement.style.animation = "flashMessage 1s ease-in-out";
        }

        return false;
      }

      // Button is enabled, proceed to checkout
      window.location.href = "/checkout";
    });
  }
}

// Set up a mutation observer to detect when EComposer content is added
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node contains cart icons or is one itself
          if (node.id === 'cart-icon-bubble-test' || node.id === 'cart-icon-bubble' ||
              node.querySelector && (
                node.querySelector('#cart-icon-bubble-test') || 
                node.querySelector('#cart-icon-bubble')
              )) {
            console.log('EComposer cart icon detected via mutation observer, setting up handlers...');
            setTimeout(() => {
              if (initializeCartToggle()) {
                console.log('Successfully initialized cart toggle from mutation observer');
              }
            }, 100);
          }
        }
      });
    }
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Extended retry mechanism - try every second for 30 seconds
let cartRetryCount = 0;
const cartMaxRetries = 30;
const cartRetryInterval = setInterval(() => {
  cartRetryCount++;
  console.log(`Retry attempt ${cartRetryCount} of ${cartMaxRetries} to find cart toggle...`);
  
  if (initializeCartToggle()) {
    console.log('Cart toggle found and initialized on retry', cartRetryCount);
    clearInterval(cartRetryInterval);
  } else if (cartRetryCount >= cartMaxRetries) {
    console.log('Max retries reached, stopping cart toggle search');
    clearInterval(cartRetryInterval);
  }
}, 1000);

// Use event delegation to handle clicks on cart icons (most reliable approach)
document.addEventListener('click', function(e) {
  console.log('Click detected on:', e.target.id, e.target.className);
  
  // Check if clicked element or its parent is a cart icon
  let cartElement = null;
  
  // Direct click on cart icon
  if (e.target.id === 'cart-icon-bubble-test' || e.target.id === 'cart-icon-bubble') {
    cartElement = e.target;
  }
  
  // Click on child element (like SVG inside the cart link)
  if (!cartElement) {
    cartElement = e.target.closest('#cart-icon-bubble-test, #cart-icon-bubble, a[href="#cart"]');
  }
  
  if (cartElement) {
    console.log("CLICKED cart toggle - found element:", cartElement.id);
    
    // Try to set up the cart toggle if it hasn't been set up yet
    if (!cartElement.hasAttribute('data-cbi-cart-setup')) {
      console.log('Cart element not yet setup, setting up now...');
      setupCartToggle(cartElement);
    }
    
    e.preventDefault();
    e.stopPropagation();
    showCBICart();
  }
}, true); // Use capture phase to catch events early

// Stop mutation observer after 35 seconds to prevent performance issues
setTimeout(() => {
  observer.disconnect();
  console.log('Cart toggle mutation observer disconnected');
}, 35000);

function findSpecificElement(item, targetId) {
  const elem = item.parentNode.querySelector(`#${targetId}`);
  if (elem) return elem;
  return null;
}

function disableButton(item) {
  item.setAttribute("disabled", "");
  item.style.opacity = "0.5";
  item.style.cursor = "default";
}

function enableButton(item) {
  item.removeAttribute("disabled");
  item.style.opacity = "1";
  item.style.cursor = "pointer";
}

function showMinLimit(item) {
  const minLimit = findSpecificElement(item, 'limit-message-container-min');
  if (minLimit) {
    minLimit.removeAttribute("hidden");
  }
}

function hideMinLimit(item) {
  const minLimit = findSpecificElement(item, 'limit-message-container-min');
  if (minLimit) {
    minLimit.setAttribute("hidden", "");
  }
}

function showMaxLimit(item) {
  const maxLimit = findSpecificElement(item, 'limit-message-container-max');
  if (maxLimit) {
    maxLimit.removeAttribute("hidden");
  }
}

function hideMaxLimit(item) {
  const maxLimit = findSpecificElement(item, 'limit-message-container-max');
  if (maxLimit) {
    maxLimit.setAttribute("hidden", "");
  }
}

function checkMinimumBottles() {
  const minBottlesElement = document.querySelector('#minimum-bottles-message #cart-minimum-bottles-qty');
  if (minBottlesElement) {
    const min_bottles = minBottlesElement ? parseInt(minBottlesElement.textContent, 10) : 1;
    // Count the total of items that are not alcoholic beverages
    const nonAlcoholicItems = document.querySelectorAll("[data-category='non-alcoholic']");
    // Count the total number of bottles in the cart
    const productDetails = document.querySelectorAll("[data-category='alcoholic-beverage']");
    // Hide the message if there are no items in the cart
    if (productDetails.length === 0 && nonAlcoholicItems.length === 0) {
      document.getElementById('minimum-bottles-message').style.display = 'none';
      return;
    }
    // Enable checkout if there are only non-alcoholic items in the cart
    if (nonAlcoholicItems.length > 0 && productDetails.length === 0) {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "none";
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute("disabled");
        checkoutButton.classList.remove("disabled");
        checkoutButton.classList.add("checkout-button");
      }
      return;
    }
    // Count the total number of bottles per item
    let totalBottles = 0;
    productDetails.forEach(product => {
      const description = product.querySelector('.description span');
      const currentValue = parseInt(product.querySelectorAll("input[type=text]")[0].value);
      let bottleCount = 0;
      // Check if the description contains a number with the format "X bottles"
      if (description) {
        bottleCount = parseInt(description.textContent, 10) * currentValue;
      } else {
        bottleCount = currentValue;
      }
      totalBottles += bottleCount;
    });
    // Check if the total number of bottles is less than the minimum required
    if (totalBottles < min_bottles) {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "block";
        // Ensure message is visible immediately
        messageElement.style.opacity = "1";
        messageElement.style.visibility = "visible";
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.setAttribute("disabled", "disabled");
        checkoutButton.classList.remove("checkout-button");
        checkoutButton.classList.add("disabled");
      }
    } else {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "none";
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute("disabled");
        checkoutButton.classList.remove("disabled");
        checkoutButton.classList.add("checkout-button");
      }
    }
  }
}

// Debounce function to avoid too many rapid calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Debounced version of checkMinimumBottles
const debouncedCheckMinimumBottles = debounce(checkMinimumBottles, 100);

function validateBoundaries(item, productKey, min=1, max=500, isMinDisplayed=true) {
  const currentValue = parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value);
  if (currentValue <= min) {
    hideMaxLimit(item.parentNode.parentNode);
    if (isMinDisplayed && min > 1) showMinLimit(item.parentNode.parentNode);
    disableButton(item.parentNode.querySelectorAll("button")[0]);
    enableButton(item.parentNode.querySelectorAll("button")[1]);
    item.parentNode.querySelectorAll("input[type=text]")[0].value = min.toString();
    updateItemQuantityInCart(min, productKey);
  } else if (currentValue >= max) {
    hideMinLimit(item.parentNode.parentNode);
    showMaxLimit(item.parentNode.parentNode);
    disableButton(item.parentNode.querySelectorAll("button")[1]);
    enableButton(item.parentNode.querySelectorAll("button")[0]);
    item.parentNode.querySelectorAll("input[type=text]")[0].value = max.toString();
    updateItemQuantityInCart(max, productKey);
  } else {
    enableButton(item.parentNode.querySelectorAll("button")[0]);
    enableButton(item.parentNode.querySelectorAll("button")[1]);
    hideMinLimit(item.parentNode.parentNode);
    hideMaxLimit(item.parentNode.parentNode);
    updateItemQuantityInCart(currentValue, productKey);
  }
}

function decrementQuantity(item, productKey, step=1, min=1) {
  const currentValue = parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value);
  hideMaxLimit(item.parentNode.parentNode);
  if (currentValue >= min) {
    let newValue = currentValue - step;
    if (newValue <= min) {
      newValue = min;
      disableButton(item);
      enableButton(item.parentNode.querySelectorAll("button")[1]);
      if (min > 1) showMinLimit(item.parentNode.parentNode);
      item.parentNode.querySelectorAll("input[type=text]")[0].value = min.toString();
    } else {
      hideMinLimit(item.parentNode.parentNode);
      enableButton(item.parentNode.querySelectorAll("button")[1]);
      item.parentNode.querySelectorAll("input[type=text]")[0].value = newValue.toString();
    }
    updateItemQuantityInCart(newValue, productKey);
  }
}

function incrementQuantity(item, productKey, step=1, max=500) {
  const currentValue = parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value);
  hideMinLimit(item.parentNode.parentNode);
  if (currentValue <= max) {
    let newValue = currentValue + step;
    if (newValue >= max) {
      newValue = max;
      disableButton(item);
      enableButton(item.parentNode.querySelectorAll("button")[0]);
      showMaxLimit(item.parentNode.parentNode);
      item.parentNode.querySelectorAll("input[type=text]")[0].value = max.toString();
    } else {
      hideMaxLimit(item.parentNode.parentNode);
      enableButton(item.parentNode.querySelectorAll("button")[0]);
      item.parentNode.querySelectorAll("input[type=text]")[0].value = newValue.toString();
    }
    updateItemQuantityInCart(newValue, productKey);
  }
}

function updateItemQuantity(quantity, productKey) {
  const cart_product_item = document.getElementById(productKey);
  if (cart_product_item) {
    cart_product_item.querySelectorAll("input[type=text]")[0].value = quantity.toString();
  }
}

function fetchSection(sectionId) {
  fetch(window.Shopify.routes.root + '?sections=' + sectionId, {
    method: 'GET',
  })
  .then(response => {
    return response.json();
  })
  .then((data) => {
    const parser = new DOMParser();
    const newSection = parser.parseFromString(data['cbi-cart'], 'text/html');
    const CBICartWrapper = newSection.getElementById('cbi-cart_wrapper');
    const currentCartWrapper = document.getElementById('cbi-cart_wrapper');
    if (CBICartWrapper && currentCartWrapper) {
      // Ensure new cart shell starts without animation enabled
      const newCartShell = CBICartWrapper.querySelector('.cbi-cart_shell');
      if (newCartShell) {
        newCartShell.classList.remove('animate-ready');
      }
      
      currentCartWrapper.remove();
      document.getElementById('shopify-section-cbi-cart').appendChild(CBICartWrapper);
    }
  });
}
function displayErrorInCollectionPage(formData, data) { 
  const pdpCardsErrors = document.querySelectorAll('.product-card-error');
  pdpCardsErrors.forEach(elem => elem.remove());
  if (!formData || !data || !data.message) return;
  let fd;
  try {
    fd = JSON.parse(formData);
  } catch (e) {
    console.error('Invalid JSON in formData:', formData);
    return;
  }
  const variantId = fd?.items?.[0]?.id;
  if (!variantId) return;

  const container = document.querySelector(`.prod_card[data-productvarient="${variantId}"]`);
  if (!container) return;

  const btnWrapper = container.querySelector('.product-card-btn-container');
  if (!btnWrapper) return;

  const errorDiv = document.createElement('div');
  errorDiv.className = 'product-card-error';
  errorDiv.textContent = data.message;
  errorDiv.style.fontSize="12px";
  errorDiv.style.color="red";
  btnWrapper.prepend(errorDiv);
}

function addToCart(formData, isJson = true) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: isJson ? {
      'Content-Type': 'application/json'
    } : {},
    body: formData
  })
  .then(response => response.json())
  .then(async (data) => {

    if (data.status == 422) {
      /* Display cart errors if they are present. */
      displayError(data.message);
      // Display error in pdp page 
      if(document.getElementById('pdp-cart-error'))
      {
        document.getElementById('pdp-cart-error').innerText=data.message;
      }
      // display erros pdp-card collection page
      displayErrorInCollectionPage(formData,data) 
    } else {

    // @TODO REMOVE ONCE BLOOM IS DECOUPLED
    if (window.CBI_CART_PANEL_ENABLED === false) {   
      bloomFetchCart();
      return
    }
    displayErrorInCollectionPage([],[]);
    fetchSection('cbi-cart');
    setTimeout(() => {
      showCBICart();
      checkMinimumBottles();
      document.dispatchEvent(new Event("cart:add"));
      document.dispatchEvent(new Event("cart:updated"));
      if (data.status == 422) {
        displayError(data.message);
      } else {
        document.dispatchEvent(new CustomEvent("cart:checkLimits", {
          detail: {
            itemId: data.id
        }}));
      }
    }, 500);
  }
  })
  .catch(function (error) {
    displayError(error.message);
  });
}

function handleAddToCart(quantity, key) {
  // If the CBI cart panel is not enabled, use the old add to cart method
  // @TODO REMOVE CONDITION ONCE BLOOM IS DECOUPLED
  // also, remove the "item" parameter and all references to it in other handleAddToCart calls
  // if (window.CBI_CART_PANEL_ENABLED === false) {
  //   bloomAddToCart(key, item);
  //   return;
  // }

  let itemToAdd = {
    items: [{
      id: key.toString(),
      quantity: quantity,
    }]
  };
  addToCart(JSON.stringify(itemToAdd));
}

function updateItemQuantityInCart(quantity, key) {
  let itemUpdate = {
    id: key.toString(),
    quantity: quantity,
  };
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(itemUpdate)
  })
  .then(response => {
    return response.json();
  })
  .then(async (data) => {
    if (data.status == 422) {
      displayError(data.message);
      document.dispatchEvent(new CustomEvent("cart:checkItemInventory", {
        detail: {
          itemId: key
      }}));
    } else {
      if (data.item_count === 0) {
        // updateCartCounter(0);
      }
      if (document.querySelector("#cart-error")) {
        document.querySelector("#cart-error").remove();
      }
      if (quantity === 0) {
        removeItemFromCart(key);
      }
      checkMinimumBottles();
      document.dispatchEvent(new Event("cart:updated"));
    }
  })
  .catch((error) => {
    displayError(error.message);
  });
}

function removeItemFromCart(productKey) {
  let totalValue = document.getElementById(productKey);
  if (totalValue) {
    totalValue.remove();
  }
}

function displayError(errorMessage) {
  var errorTag = document.createElement("div");
  errorTag.id = ("cart-error");
  errorTag.classList.add("cart-error-message");
  errorTag.classList.add("mt-2");
  errorTag.style.fontSize = "12px";
  errorTag.style.fontWeight = "600";
  errorTag.style.color = "#DC1212";

  // Create a close button
  const closeButton = document.createElement("span");
  closeButton.classList.add("close-button");
  closeButton.innerText = "X";

  // Add click event to remove the error div
  closeButton.addEventListener("click", () => {
    errorTag.remove();
  });

  // Append the close button to the error tag
  errorTag.innerText = errorMessage;
  errorTag.appendChild(closeButton);
  if (document.querySelector("#cart-error")) {
    document.querySelector("#cart-error").remove();
  }
  var eElement = document.querySelector("#product-list-container");
  eElement.insertBefore(errorTag, eElement.querySelector(".cart-product-item"));
}

document.addEventListener("cart:checkLimits", async (event) => {
  const itemId = event.detail?.itemId?.toString();
  if (itemId) {
    const min_purchase = document.getElementById('min-purchase-' + itemId);
    const max_purchase = document.getElementById('max-purchase-' + itemId);
    const min_purchase_value = min_purchase ? parseInt(min_purchase.innerText, 10) : 1;
    const max_purchase_value = max_purchase ? parseInt(max_purchase.innerText, 10) : 500;
    const inputField = document.getElementById(itemId).querySelectorAll("input[type=text]")[0];
    const currentValue = parseInt(inputField.value);
    if (currentValue <= min_purchase_value || currentValue >= max_purchase_value) {
      const isMinDisplayed = min_purchase_value > 1 ? true : false;
      validateBoundaries(inputField, itemId, min_purchase_value, max_purchase_value, isMinDisplayed);
    }
  }
});

document.addEventListener("cart:checkLimits", async () => {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart data");
    const cart = await response.json();
    cart.items.forEach((item) => {
      const itemId = item.id.toString();
      const inputField = document.getElementById(itemId).querySelectorAll("input[type=text]")[0];
      const currentValue = parseInt(inputField.value);
      if (item.quantity !== currentValue) {
        updateItemQuantityInCart(currentValue, itemId);
      }
    });
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
});

document.addEventListener("cart:checkItemInventory", async (event) => {
  try {
    const itemId = event.detail?.itemId?.toString();
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart data");
    const cart = await response.json();
    const itemChanged = cart.items.find(item => item.id.toString() === itemId);
    if (itemChanged) {
      const newQuantity = itemChanged.quantity;
      const inputField = document.getElementById(itemId).querySelectorAll("input[type=text]")[0];
      enableButton(inputField.parentNode.querySelectorAll("button")[0]);
      enableButton(inputField.parentNode.querySelectorAll("button")[1]);
      hideMinLimit(inputField.parentNode.parentNode);
      hideMaxLimit(inputField.parentNode.parentNode);
      document.getElementById(itemId).querySelectorAll("input[type=text]")[0].value = newQuantity.toString();
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
});

// ---------------------------------------------------------------------------
//
// START Old Bloom Code
// @TODO REMOVE ONCE BLOOM IS DECOUPLED
//
function bloomAddToCart(v_id, item) {
  const inputElement = item.parentNode.querySelectorAll("input[type=text]")[0];
  
  let quantityValue = inputElement?.value;
  
  if (!inputElement) {
    quantityValue = "1";
  }

  addAndOpenCart(
    v_id,
    quantityValue
  );
  
  if (item.parentNode.querySelectorAll("input[type=text]")[0].value == "") {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = 1;
  }
  }
async function addAndOpenCart(id, quantity, properties) {
  // Add item to Bloom cart
  await bloom
    .shoppingCart()
    .add([{ id: id, quantity: quantity, properties: properties || {} }]);
  
  // Reload cart data to ensure it's up to date
  await bloom.reloadCart();
  
  // Dispatch cart updated event
  document.dispatchEvent(new Event("cart:updated"));  
  
  // Show the Bloom cart directly (don't use cartToggle which might trigger CBI cart)
  bloom.showCart();
}

async function bloomFetchCart() {
  try {
    const cart = await window.bloomCart.get();
    
    if (cart) {
      document.getElementById('cart-counter').textContent = cart.item_count;
      
      // Reload the Bloom cart UI to make sure it shows the updated items
      await bloom.reloadCart();
      
      setTimeout(() => {
        document.getElementById('cart-counter').click();
      }, 500);
      
    } else {
      console.error('cart not found');
    }
  } catch (error) {
    console.error('Error in bloomFetchCart:', error);
  }
}
//
// END Old Bloom Code
//
// ---------------------------------------------------------------------------